
export const categories = {
    nice: 'NICE',
    caseload: 'Caseload',
   // outcomes: 'Outcomes' //as 2 outcome measure wasn't necessary anymore as that was calcualted differently, when this possibility is added,
   // to set outcome indicators, remove 2 outcome measure as a possibility.
};
